import { createAsyncThunk } from '@reduxjs/toolkit'

import callAPI from 'api'
import { Fail, Success } from 'store/types'

import { DismissReminderPayload, GetLeadActivityReminders } from './types/reminder'

export const dismissReminder = createAsyncThunk<Fail | Success<{ success: boolean }>, DismissReminderPayload>(
  'reminder/dismissReminder',
  async (payload) => await callAPI('crm_dismiss_reminder', [payload], { requireAuthorization: true }),
)

export const getReminders = createAsyncThunk<Fail | Success<GetLeadActivityReminders>>(
  'remeinder/getReminders',
  async () => await callAPI<GetLeadActivityReminders>('crm_get_reminders', undefined, { requireAuthorization: true }),
)
